/******/ (() => { // webpackBootstrap
  var __webpack_exports__ = {};
  Shopify.theme.jsRecommendedProducts = {
    init: function ($section) {

      // Add settings from schema to current object
      Shopify.theme.jsRecommendedProducts = $.extend(this, Shopify.theme.getSectionData($section));

      // Look for an element with class 'product-recommendations'
      const $productRecommendations = $section.find('.product-recommendations');

      // Selectors
      const productID = $productRecommendations.data('product-id');
      const limit = $productRecommendations.data('limit');  
      const sectionID = $productRecommendations.data('section-id');

      // If showing custom collection we do not want to build request url 
      if (this.show_custom_collection) {
        this.showCustomCollection($section);
        return;
      }

      // Build request URL
      const shopURL = $productRecommendations.data('base-url');
      const requestUrl = `/recommendations/products.json?product_id=${productID}&limit=${limit}&intent=related`;
      fetch(requestUrl)
      .then(response => response.json())
      .then(({ products }) => { 
        let total_length = 0;
        if (products.length > 0) {
           let all_products_html = '<div class="container has-column-padding-bottom featured-collection layout--grid is-justify-center">';

           for(let j=0;j<products.length;j++){ 
             let product_exist = false;
             if(all_child_products){
               for(let k=0;k<all_child_products.length;k++){
                 if(products[j].id == all_child_products[k].id){
                   product_exist=true;
                 }
               }               
             }

             if(!product_exist && total_length<4){
               total_length++;
               all_products_html = all_products_html + '<div class=" one-fourth medium-down--one-half small-down--one-whole column has-thumbnail-sticker thumbnail product__thumbnail thumbnail__hover-overlay--false has-padding-bottom " data-load-more--grid-item=""> <div class="product-wrap"> <div class="product-image__wrapper"> <div class="image__container product__imageContainer"> <a href="'+products[j].url+'"> <div class="image-element__wrap" style=" max-height: 240px; width: calc(129 /  225 * 240px); "> <img alt="' + shopName + '" class="transition--fade-in lazyautosizes ls-is-cached lazyloaded" data-src="'+products[j].featured_image+'" sizes="402px" src="'+products[j].featured_image+'"> </div> <noscript class="noscript"> <img class="" src="'+products[j].featured_image+'" alt=""> </noscript> </a> </div> </div> <div class="thumbnail__caption text-align-left"> <div class="product-thumbnail"> <a href="'+products[j].url+'" class="is-text product-thumbnail__title">'+products[j].title+'</a> <span class="product-thumbnail__price price is-text "> <span class="money"> '+current_currency+ (products[j].price/100 )+' </span> </span> </div> </div> </div> </div>';
             }
           }
           all_products_html = all_products_html + '</div>'; 
          if(total_length>0){
            $productRecommendations.html(all_products_html);
          }else{
            $productRecommendations.parents('.recommended-products-section').hide();
          }
          // Initialize shopify payment buttons
          if (Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }

          // Converting the currencies
          if (Shopify.theme.currencyConverter) {
            Shopify.theme.currencyConverter.convertCurrencies();
          }          
        }


      });
    },
    showCustomCollection: function ($section) {
      const $recommendedProductsElement = $section.find('.product-recommendations').html();

      const $productRecommendationsContainer = $('.product-recommendations');
      $productRecommendationsContainer.html($recommendedProductsElement);

      Shopify.theme.jsProduct.relatedProducts($section);
    },
    unload: function ($section) {
    }
  }

  /******/
})()
  ;